/* eslint-disable react/require-default-props,react/destructuring-assignment,react/no-access-state-in-setstate,react/prop-types */

import React from 'react';
import PropTypes from 'prop-types';
import { RackspaceCdnFileUploader } from '../RackspaceCdnFileUploader/RackspaceCdnFileUploader';
import { ImagePreviewDropZone } from './ImagePreviewDropZone';
import { IconTooltip } from '../Tooltip/IconTooltip';
import {
  FILE_EXTENSION_ERROR_TITLE,
  FILE_EXTENSION_ERROR_DESCRIPTION,
} from '../Uploader/constants';
import { isInvalidFileExtentionError } from '../Uploader/FileHelpers';
import { alertDialog } from '../Modals/AlertDialog';
import './ImageUploader.scss';
import { resizeImageFile } from '../Uploader/helpers/imageResize';

export class ImageUploader extends React.Component {
  static propTypes = {
    imageUrl: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    suggestedSize: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
      // assuming this will be in pixels
    }),
    displaySuggestedSize: PropTypes.bool,
    resizeToSize: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }),
  };

  static defaultProps = {
    displaySuggestedSize: true,
  };

  state = {
    image: null,
    upload: null,
  };

  componentWillMount() {
    if (this.props.imageUrl) {
      this.setState({ image: this.props.imageUrl });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.imageUrl !== this.state.image) {
      this.setState({ image: nextProps.imageUrl });
    }
  }

  uploadFile = (file) => {
    const reader = new FileReader();

    reader.onload = () => {
      this.setState({
        upload: { ...this.state.upload, preview: reader.result },
      });
    };
    this.setState({
      upload: { preview: null, progress: 0 },
      image: null,
    });
    reader.readAsDataURL(file);
    this.imageUploader.startUploads([file]);
  };

  handleFileSelected = (files) => {
    const file = files[0];
    const { resizeToSize } = this.props;

    if (resizeToSize) {
      resizeImageFile({
        file,
        width: resizeToSize.width,
        height: resizeToSize.height,
      }).then((resizedImage) => this.uploadFile(resizedImage));
    } else {
      this.uploadFile(file);
    }
  };

  handleFileProgress = (index, file, percentage) => {
    this.setState({ upload: { ...this.state.upload, progress: percentage } });
  };

  handleFileUploaded = (downloadUrls) => {
    const { upload } = this.state;
    const downloadUrl = downloadUrls[0];
    let image = downloadUrl.link;

    // continue using the preview so we don't have to download the image again.
    if (upload && upload.preview) {
      image = upload.preview;
    }
    this.setState({ image });
    this.props.onChange(downloadUrl.link);
  };

  handleUploadFailed = (errorMessage) => {
    this.setState({
      upload: null,
      image: null,
    });
    if (isInvalidFileExtentionError(errorMessage)) {
      alertDialog({
        title: FILE_EXTENSION_ERROR_TITLE,
        message: FILE_EXTENSION_ERROR_DESCRIPTION,
      });
    }
  };

  handleUploadClick = () => {
    this.imageUploader.selectFile();
  };

  handleCancelClick = () => {
    this.setState({
      image: null,
      upload: null,
    });
    this.props.onChange('');
  };

  handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.imageUploader.setFiles(event.dataTransfer.files);
  };

  handleDragOver = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const data = event.dataTransfer;
    data.dropEffect = 'copy';
  };

  render() {
    const { suggestedSize, displaySuggestedSize } = this.props;
    const { image, upload } = this.state;

    return (
      <image-uploader>
        <ImagePreviewDropZone
          {...{ image, upload, suggestedSize }}
          onUploadClick={this.handleUploadClick}
          onDragOver={this.handleDragOver}
          onDrop={this.handleDrop}
          onClear={this.handleCancelClick}
        />
        {suggestedSize && displaySuggestedSize && (
          <div className="suggested-size">
            <span>
              Suggested: <strong>{suggestedSize.width}</strong> x{' '}
              <strong>{suggestedSize.height}</strong> pixels
            </span>
            {suggestedSize.tooltip && (
              <IconTooltip icon="info-circle" tooltip={suggestedSize.tooltip} />
            )}
          </div>
        )}

        <RackspaceCdnFileUploader
          ref={(el) => {
            this.imageUploader = el;
          }}
          acceptsFormats="image/*"
          filterFile={(f) => f.type.split('/')[0] === 'image'}
          onFileProgress={this.handleFileProgress}
          onFilesSelected={this.handleFileSelected}
          onUploadsCompleted={this.handleFileUploaded}
          onUploadFailed={this.handleUploadFailed}
        />
      </image-uploader>
    );
  }
}
